/** Resolve Canvas API WebSocket base (ws/wss) from REACT_APP_API_URL. */
export function getCanvasWsBaseUrl() {
  // Host-only suite cookies authenticate sockets only on this app's origin.
  if (process.env.REACT_APP_SUITE_SSO === 'true' && process.env.NODE_ENV !== 'development') {
    return window.location.origin.replace(/^http/, 'ws');
  }
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL.replace(/\/$/, '');
  }
  const http =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development'
      ? 'http://localhost:8001'
      : window.location.origin);
  if (http.startsWith('ws://') || http.startsWith('wss://')) {
    return http.replace(/\/$/, '');
  }
  return http.replace(/^http/, 'ws').replace(/\/$/, '');
}
